// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Store Custom Code
// import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice"; // Store Custom Code
// import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText"; // Store Custom Code
// import CartLineNotes, { CartLineNotesStyles } from "@insite/content-library/Widgets/Cart/CartLineNotes"; // Store Custom Code
import CartLineQuantity, { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
// import React from "react"; // Store Custom Code
// import { connect } from "react-redux"; // Store Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
// import { productLineProps } from "@store/Themes/common/props/productLine"; // Store Custom Code
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import updateCartLine from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";
import resolveZeroPriceDisplay, {
    getCurrencyAwareZeroPriceDisplay,
} from "@store/Framework/Common/Utilities/resolveZeroPriceDisplay";
import { SplitOrderCartLineNotesModel } from "@store/Framework/Types/ApiModels";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import updateSplitOrderCartLineNotes from "@store/Framework/Store/Greif/Pages/ReviewAndSubmit/SplitOrderCartLine/Handlers/UpdateSplitOrderCartLineNotes";
import CartLinesDates, { CartLinesDeliveryDate } from "@store/Library/Components/Cart/CartLinesDates";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { SmallHeadingAndTextStyles } from "@store/Overrides/Components/SmallHeadingAndText";
import CartLineNotes, { CartLineNotesStyles } from "@store/Overrides/Widgets/Cart/CartLineNotes";
import { productLineProps } from "@store/Themes/common/props/productLine";
import React, { useContext } from "react";
import { connect } from "react-redux";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
/* Store Custom Code - End */

interface OwnProps {
    cart: Cart;
    promotions?: PromotionModel[];
    showSavingsAmount: boolean;
    showSavingsPercent: boolean;
    editable: boolean;
    showInvalidPriceMessage?: boolean;
    extendedStyles?: CartLineCardExpandedStyles;
    // Starter Custom Code
    overridedStyles?: CartLineCardExpandedStyles;
    // Store Custom Code
    isLineNotesOpen?: boolean;
    showLineNumber?: boolean;
    index: number;
    deliveryDatesUI?: boolean;
    hasSplitOrders?: boolean;
    orderLineNotesMaxLength?: number;
}

const mapStateToProps = (state: ApplicationState) => {
    const currentPageType = getCurrentPage(state).type; // Store Custom Code
    return {
        enableVat: getSettingsCollection(state).productSettings.enableVat,
        vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
        showPricing: state.context.showPricing,
        // Store Custom Code
        currentPageType,
        isCheckoutReviewAndSubmitPage: currentPageType === "CheckoutReviewAndSubmitPage",
    };
};

type Props = OwnProps & HasCartLineContext & ReturnType<typeof mapStateToProps>;

export interface CartLineCardExpandedStyles {
    cartLineNotes?: CartLineNotesStyles;
    price?: ProductPriceStyles;
    quantity?: CartLineQuantityStyles;
    container?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoContainer?: GridContainerProps;
    productDescriptionAndPartNumbersGridItem?: GridItemProps;
    productDescriptionAndPartNumbersContainer?: GridContainerProps;
    productBrand?: ProductBrandStyles;
    productBrandAndDescriptionGridItem?: GridItemProps;
    productDescription?: ProductDescriptionStyles;
    configurationGridItem?: GridItemProps;
    configurationOptionText?: TypographyProps;
    productPartNumbersGridItem?: GridItemProps;
    productPartNumbers?: ProductPartNumbersStyles;
    orderLineNotesGridItem?: GridItemProps;
    notesHeadingAndText?: SmallHeadingAndTextStyles;
    costCodeGridItem?: GridItemProps;
    costCodeValueText?: TypographyPresentationProps;
    costCodeLabelText?: TypographyPresentationProps;
    productPriceAndQuantityGridItem?: GridItemProps;
    productPriceAndQuantityContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    priceHeadingAndText?: SmallHeadingAndTextStyles;
    promotionNameText?: TypographyProps;
    quantityGridItem?: GridItemProps;
    qtyHeadingAndText?: SmallHeadingAndTextStyles;
    extendedUnitNetPriceGridItem?: GridItemProps;
    extendedUnitNetPrice?: SmallHeadingAndTextStyles;
    subtotalWithoutVatText?: SmallHeadingAndTextStyles;
    vatAmount?: SmallHeadingAndTextStyles;
    cartLineErrorMessageGridItem?: GridItemProps;
    cartLineErrorMessageText?: TypographyProps;
    // Starter Custom Code
    extendedUnitNetPriceLabel?: TypographyPresentationProps;
    extendedUnitNetPriceText?: TypographyPresentationProps;
    subtotalWithoutVat?: TypographyPresentationProps;
    vatLabelText?: TypographyPresentationProps;
    cartLineErrorMessageInfosBox?: InfosBoxProps;
    // Store Custom Code
    requestedDateGridItem?: GridItemProps;
    requestedDateLabel?: TypographyPresentationProps;
    requestedDateValue?: TypographyPresentationProps;
    requestPoGridItem?: GridItemProps;
}

export const cartLineCardExpandedStyles: CartLineCardExpandedStyles = {
    container: productLineProps.container,
    productImageGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    orderLineInfoGridItem: productLineProps.contentGridItem,
    orderLineInfoContainer: productLineProps.contentContainer,
    productDescriptionAndPartNumbersGridItem: productLineProps.infoGridItem,
    productDescriptionAndPartNumbersContainer: productLineProps.infoContainer,
    productBrandAndDescriptionGridItem: productLineProps.descriptionGridItem,
    productBrand: productLineProps.brand,
    productDescription: productLineProps.description,
    productPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbers: productLineProps.partNumbers,
    configurationGridItem: productLineProps.configurationGridItem,
    configurationOptionText: productLineProps.configuration,
    costCodeGridItem: productLineProps.costCodeGridItem,
    costCodeLabelText: productLineProps.costCodeLabel,
    costCodeValueText: productLineProps.costCodeText,
    productPriceAndQuantityGridItem: productLineProps.pricingGridItem,
    productPriceAndQuantityContainer: productLineProps.pricingContainer,
    priceGridItem: productLineProps.priceGridItem,
    price: productLineProps.price,
    promotionNameText: productLineProps.promotion,
    quantityGridItem: productLineProps.quantityGridItem,
    quantity: productLineProps.quantity,
    extendedUnitNetPriceGridItem: productLineProps.subtotalGridItem,
    extendedUnitNetPriceLabel: productLineProps.subtotalLabel,
    extendedUnitNetPriceText: productLineProps.subtotalValue,
    subtotalWithoutVat: productLineProps.subtotalSecondValue,
    vatLabelText: productLineProps.subtotalVatLabel,
    cartLineErrorMessageGridItem: productLineProps.messageGridItem,
    cartLineErrorMessageInfosBox: productLineProps.messageInfosBox,
    // Store Custom Code
    requestedDateGridItem: productLineProps.requestedDateGridItem,
    requestedDateLabel: productLineProps.requestedDateLabel,
    requestedDateValue: productLineProps.requestedDateValue,
    requestPoGridItem: productLineProps.requestPoGridItem,
};

const CartLineCardExpanded = ({
    cart,
    cartLine,
    showSavingsAmount,
    showSavingsPercent,
    promotions,
    editable,
    enableVat,
    vatPriceDisplay,
    showInvalidPriceMessage,
    showPricing,
    isCheckoutReviewAndSubmitPage,
    currentPageType, // Store Custom Code
    extendedStyles,
    // Starter Custom Code
    overridedStyles,
    // Store Custom Code
    isLineNotesOpen,
    showLineNumber,
    index,
    deliveryDatesUI,
    hasSplitOrders = false,
    orderLineNotesMaxLength,
}: Props) => {
    const styles = useExpandProps(cartLineCardExpandedStyles, extendedStyles, overridedStyles); // Starter Custom Code
    /* Store Custom Code - Start */
    const { deliveryDate, originalCartLineId } = cartLine.properties;
    const deliveryDateObj: CartLinesDeliveryDate = deliveryDate ? JSON.parse(deliveryDate) : {};

    const toasterContext = useContext(ToasterContext);
    const dispatch = useAppDispatch();
    const onQtyOrderedChange = (qtyOrdered: number) => {
        dispatch(
            updateCartLine({
                cartLine: {
                    ...cartLine,
                    qtyOrdered,
                },
            }),
        );
    };

    const notesChangeHandler = (notes: string) => {
        if (notes !== cartLine.notes) {
            dispatch(
                updateCartLine({
                    cartLine: {
                        ...cartLine,
                        notes,
                    },
                    shouldNotReloadPromotions: true,
                    shouldNotLoadFullCart: true,
                    onSuccess: () => {
                        toasterContext.addToast({
                            body: translate("Line Notes Updated"),
                            messageType: "success",
                        });
                    },
                    onComplete(resultProps) {
                        if (resultProps.apiResult) {
                            this.onSuccess?.();
                        }
                    },
                }),
            );
        }
    };

    const deliveryDateNotesChangeHandler = (notes: string) => {
        if (notes !== cartLine.notes) {
            dispatch(
                updateSplitOrderCartLineNotes({
                    splitOrderCartLineNotes: {
                        cartId: cart.id,
                        cartLineId: originalCartLineId,
                        id: deliveryDateObj.id,
                        notes,
                    } as SplitOrderCartLineNotesModel,
                    onSuccess: () => {
                        toasterContext.addToast({
                            body: translate("Line Notes Updated"),
                            messageType: "success",
                        });
                    },
                    onComplete(resultProps) {
                        if (resultProps.apiResult) {
                            this.onSuccess?.();
                        }
                    },
                }),
            );
        }
    };

    const subtotalDecision = resolveZeroPriceDisplay({
        context: "lineSubtotal",
        pricing: cartLine.pricing,
        pageType: currentPageType || "",
    });
    const zeroPriceDisplay = getCurrencyAwareZeroPriceDisplay(cart.currencySymbol);
    const subtotalDisplay = subtotalDecision.showDash
        ? zeroPriceDisplay
        : enableVat && vatPriceDisplay !== "DisplayWithoutVat"
          ? cartLine.pricing?.extendedUnitRegularPriceWithVatDisplay
          : cartLine.pricing?.extendedUnitNetPriceDisplay;
    const subtotalWithoutVatDisplay = subtotalDecision.showDash
        ? zeroPriceDisplay
        : cartLine.pricing?.extendedUnitNetPriceDisplay;
    /* Store Custom Code - End */

    return (
        <GridContainer
            {...styles.container}
            data-test-selector={`cartline_expanded_${cartLine.productId}_${cartLine.unitOfMeasure}`}
        >
            {/* Starter Custom Code - Start */}
            {(cartLine.isRestricted || !cartLine.isActive) && (
                <GridItem {...styles.cartLineErrorMessageGridItem}>
                    {cartLine.isRestricted && (
                        <InfosBox
                            {...styles.cartLineErrorMessageInfosBox}
                            data-test-selector="cartline_restrictedMessage"
                        >
                            {translate("Restricted product")}
                        </InfosBox>
                    )}
                    {!cartLine.isActive && (
                        <InfosBox
                            {...styles.cartLineErrorMessageInfosBox}
                            data-test-selector="savedordercartline_inactiveErrorMessage"
                        >
                            {translate("Inactive Product")}
                        </InfosBox>
                    )}
                </GridItem>
            )}
            {/* Starter Custom Code - End */}
            <GridItem {...styles.productImageGridItem}>
                <ProductImage product={cartLine} extendedStyles={styles.productImage} />
            </GridItem>
            <GridItem {...styles.orderLineInfoGridItem}>
                <GridContainer {...styles.orderLineInfoContainer}>
                    <GridItem {...styles.productDescriptionAndPartNumbersGridItem}>
                        <GridContainer {...styles.productDescriptionAndPartNumbersContainer}>
                            <GridItem {...styles.productBrandAndDescriptionGridItem}>
                                {cartLine.brand && (
                                    <ProductBrand brand={cartLine.brand} extendedStyles={styles.productBrand} />
                                )}
                                <ProductDescription product={cartLine} extendedStyles={styles.productDescription} />
                            </GridItem>
                            {/* Starter Custom Code - Start */}
                            <GridItem {...styles.productPartNumbersGridItem}>
                                <ProductPartNumbers
                                    productNumber={cartLine.erpNumber}
                                    customerProductNumber={cartLine.customerName}
                                    manufacturerItem={cartLine.manufacturerItem}
                                    extendedStyles={styles.productPartNumbers}
                                    // Store Custom Code
                                    showLineNumber={showLineNumber}
                                    cartLineNumber={cartLine.line}
                                    showAdditionalInfo={true}
                                    index={index}
                                    pricing={cartLine.pricing}
                                />
                            </GridItem>
                            {/* Starter Custom Code - End */}
                            {!cartLine.isFixedConfiguration && cartLine.sectionOptions!.length > 0 && (
                                <GridItem {...styles.configurationGridItem}>
                                    {cartLine.sectionOptions!.map(option => (
                                        <Typography {...styles.configurationOptionText} key={option.sectionOptionId}>
                                            {`${option.sectionName}:${option.optionName}`}
                                        </Typography>
                                    ))}
                                </GridItem>
                            )}
                            {/* Starter Custom Code - Start */}
                            {cart.showCostCode && cartLine.costCode && (
                                <GridItem {...styles.costCodeGridItem} data-test-selector="orderConformation_CostCode">
                                    <Typography {...styles.costCodeLabelText}>{cart.costCodeLabel}</Typography>
                                    <Typography {...styles.costCodeValueText}>{cartLine.costCode}</Typography>
                                </GridItem>
                            )}
                            {/* Starter Custom Code - End */}
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.productPriceAndQuantityGridItem}>
                        <GridContainer {...styles.productPriceAndQuantityContainer}>
                            {(showPricing || isCheckoutReviewAndSubmitPage) /* Starter Custom Code */ && (
                                <GridItem {...styles.priceGridItem}>
                                    <ProductPrice
                                        product={cartLine}
                                        showSavings={true}
                                        showSavingsAmount={showSavingsAmount}
                                        showSavingsPercent={showSavingsPercent}
                                        showInvalidPriceMessage={showInvalidPriceMessage}
                                        extendedStyles={styles.price}
                                        zeroPriceContactUsLayout="block" /* Store Custom Code */
                                    />
                                    {/* Starter Custom Code - Start */}
                                    {promotions && promotions.length > 0 && (
                                        <Typography
                                            {...styles.promotionNameText}
                                            data-test-selector="orderLineCardExpandedPromotionName"
                                        >
                                            {translate("{0}:", translate("Promotions"))}{" "}
                                            {promotions.map(x => x.name).join(", ")}
                                        </Typography>
                                    )}
                                    {/* Starter Custom Code - End */}
                                </GridItem>
                            )}
                            <GridItem {...styles.quantityGridItem} data-test-selector="orderConformation_Quantity">
                                <CartLineQuantity
                                    cart={cart}
                                    editable={false} // Store Custom Code
                                    extendedStyles={styles.quantity}
                                    // Store Custom Code
                                    onQtyOrderedChange={onQtyOrderedChange}
                                />
                            </GridItem>
                            {/* Starter Custom Code - Start */}
                            {cartLine.pricing && (showPricing || isCheckoutReviewAndSubmitPage) && (
                                <GridItem {...styles.extendedUnitNetPriceGridItem}>
                                    <Typography {...styles.extendedUnitNetPriceLabel}>
                                        {translate("Subtotal")}
                                    </Typography>
                                    <Typography {...styles.extendedUnitNetPriceText}>
                                        {subtotalDisplay /* Store Custom Code */}
                                    </Typography>
                                    {enableVat && (
                                        <>
                                            <Typography {...styles.vatLabelText}>
                                                {vatPriceDisplay === "DisplayWithVat" ||
                                                vatPriceDisplay === "DisplayWithAndWithoutVat"
                                                    ? `${translate("Inc. VAT")} (${cartLine.pricing.vatRate}%)`
                                                    : translate("Ex. VAT")}
                                            </Typography>
                                            {vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                                                <>
                                                    <Typography {...styles.subtotalWithoutVat}>
                                                        {subtotalWithoutVatDisplay /* Store Custom Code */}
                                                    </Typography>
                                                    <Typography {...styles.vatLabelText}>
                                                        {translate("Ex. VAT")}
                                                    </Typography>
                                                </>
                                            )}
                                        </>
                                    )}
                                </GridItem>
                            )}
                            {/* Starter Custom Code - End */}
                        </GridContainer>
                    </GridItem>
                </GridContainer>
                {/* Starter Custom Code - Start */}
                {/* Store Removed - CartLineNotes */}
                {/* Starter Custom Code - End */}
                {/* Store Custom Code - Start */}
                {deliveryDatesUI && <CartLinesDates cart={cart} key={cartLine.id} />}
                {/* Store Custom Code - End */}
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps)(withCartLine(CartLineCardExpanded));
